import {
  IconButton,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import GridDates from "./GridDates";
import Add from "@mui/icons-material/Add";
import { useMemo, useState } from "react";
import { v4 as uuid } from "uuid";
import { DeleteIcon } from "../Icons";

type Props = {
  currentQuestion: any;
};

const InputField = () => {
  return (
    <TextField
      name="textValue"
      fullWidth
      sx={{ width: 250 }}
      placeholder="Enter Value"
    />
  );
};

const NumberField = () => {
  return (
    <TextField
      type="number"
      name="numberValue"
      // fullWidth
      sx={{ display: "flex", minWidth: 125, maxWidth: "100%" }}
      placeholder="Enter Numeric Value"
    />
  );
};

const SelectField = ({ choices }: { choices: string[] }) => {
  return (
    <Select fullWidth sx={{ width: 250 }} id="position" defaultValue={""}>
      {choices?.map((choice, i) => (
        <MenuItem key={i} value={choice}>
          {choice}
        </MenuItem>
      ))}
    </Select>
  );
};

const RepeatedFieldPreview = ({ currentQuestion }: Props) => {
  const { properties } = currentQuestion;
  const rowAggregate = properties?.repeatedConfig.rowAggregate;
  const repeatedConfig = properties?.repeatedConfig.columns;

  const columnAggregate = useMemo(() => {
    return repeatedConfig.some((col: any) => !!col.aggregateType);
  }, [repeatedConfig]);

  const [array, setArray] = useState<string[]>([uuid()]);

  return (
    <div className="simple-preview-wrapper">
      <TableContainer>
        <Table
          aria-label="simple table"
          sx={{
            maxWidth: "100%",
            width: "auto",
          }}
        >
          <TableHead
            sx={{
              bgcolor: "secondary.main",
            }}
          >
            <TableRow>
              <TableCell component="th" scope="row">
                Row No
              </TableCell>
              {repeatedConfig?.map((col: any, i: number) => (
                <TableCell key={i} component="th" scope="row">
                  {col.label}
                </TableCell>
              ))}
              {rowAggregate && (
                <TableCell
                  component="th"
                  scope="row"
                  sx={{ textTransform: "capitalize" }}
                >
                  {rowAggregate}
                </TableCell>
              )}
              <TableCell component="th" scope="row">
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              "& td": {
                padding: "0px",
              },
            }}
          >
            {array?.map((id, i) => (
              <TableRow
                key={i}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell sx={{ minWidth: "85px", textAlign: "center" }}>
                  {i + 1}
                </TableCell>
                {repeatedConfig?.map((col: any, j: number) => (
                  <TableCell key={j}>
                    {col.type === "text" ? (
                      <InputField />
                    ) : col.type === "number" ? (
                      <NumberField />
                    ) : col.type === "date" ? (
                      <GridDates dateFormat={col?.format!} />
                    ) : (
                      <SelectField choices={col.options || []} />
                    )}
                  </TableCell>
                ))}
                {rowAggregate && (
                  <TableCell sx={{ minWidth: "85px" }}></TableCell>
                )}
                <TableCell sx={{ display: "flex", gap: "10px" }}>
                  <IconButton
                    onClick={() => {
                      setArray((prevArray) => [...prevArray, uuid()]);
                    }}
                  >
                    <Add color="primary" />
                  </IconButton>
                  {i !== 0 && (
                    <IconButton
                      onClick={() => {
                        setArray((prevArray) =>
                          prevArray.filter((arrId) => arrId !== id)
                        );
                      }}
                      sx={{ height: 40, width: 40 }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {columnAggregate && (
              <TableRow
                key={"col-aggregate"}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component={"th"} scope={"row"}>
                  Aggregate
                </TableCell>
                {repeatedConfig?.map((col: any, j: number) => (
                  <TableCell
                    key={j}
                    sx={{
                      textTransform: "capitalize",
                      textAlign: !col.aggregateType ? "center" : "auto",
                    }}
                  >
                    {col.aggregateType ? col.aggregateType + " : " : "-"}
                  </TableCell>
                ))}
                {rowAggregate && (
                  <TableCell sx={{ minWidth: "85px" }}></TableCell>
                )}
                <TableCell sx={{ display: "flex", gap: "10px" }}></TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default RepeatedFieldPreview;
